import React, { Fragment, useMemo } from "react";
import { Row, Col, CardBody, Button, Badge } from "reactstrap";
import { Link } from "react-router-dom";
import { Tabs, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import BootstrapTable from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useGetUserSubscriptionsQuery } from "../../../../store/api/userManagementApi";
import Loader from "../../../common/Loader";
import { isCorporateSubscription, formatValidTo } from "./corporateSubscription";
import '../styles.css';
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useSelector } from "react-redux";

const SubscriptionLists = () => {
  console.log("Rendering SubscriptionLists");
  const history = useHistory();
  const userData = useSelector(state => state.userManagement.userData) || {};
  const user_id = userData?.user_id;
  const email = userData?.user_email;

  const handleAddMoreClick = () => {
    history.push("/operations/editUser/add_sub", {
      user_email: email,
      user_id,
      ...userData,
    });
  };

  const { data: subscriptionResponse, isLoading } = useGetUserSubscriptionsQuery(user_id, {
    skip: !user_id
  });
  const data = subscriptionResponse?.data || [];

  const report = useMemo(() => {
    return data.map(element => ({
      ...element,
      // Corporate group subscriptions are managed from the corporate group, not here.
      editMore: isCorporateSubscription(element) ? (
        <span
          title="Managed by the corporate group"
          aria-label="Managed by the corporate group"
          style={{ opacity: 0.35, cursor: "not-allowed" }}
        >
          <FontAwesomeIcon icon={faEdit} size="1x" />
        </span>
      ) : (
        <Link
          to={{
            pathname: "/operations/subeditmore_v2",
            state: {
              ...element,
              email: email,
              userData: userData,
            },
          }}
        >
          <FontAwesomeIcon icon={faEdit} size="1x" />
        </Link>
      ),
    }));
  }, [data, email, userData]);

  const columns = [
    {
      dataField: "subscription_type_name",
      text: "Subscription",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
      footer: "",
      formatter: (name, row) => (
        <>
          {name}
        </>
      ),
    },
    {
      dataField: "mode_of_payment",
      text: "Mode Of Payment",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
      footer: "",
      formatter: (mode, row) => (mode ? mode : ''),
    },
    {
      dataField: "valid_from",
      text: "Valid From",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
      footer: "",
    },
    {
      dataField: "valid_to",
      text: "Valid To",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
      footer: "",
      formatter: validTo => formatValidTo(validTo),
    },
    {
      dataField: "price",
      text: "Amount",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
      footer: "",
    },
    {
      dataField: "editMore",
      text: "Edit",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
      footer: "",
    },
  ];

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <h5 className="section-heading">Subscription Details</h5>
        <Button
          color="primary"
          style={{minWidth: '150px'}}
          className="m-2 add-subscription-btn"
          onClick={handleAddMoreClick}
        >
          Add Subscription
        </Button>
      </div>

      <CardBody className="bg-light">
        <Tabs>
          <TabPanel>
            <Row noGutters style={{ margin: "3rem 0 0 0" }}>
              <Col lg={12} className="pr-lg-3">
                {data && (
              <Fragment>
                <div className="table-responsive">
                  <BootstrapTable
                    bootstrap4
                    keyField="id"
                    data={report?.map((element, index) => {
                      return { ...element, slno: index + 1 };
                    })}
                    columns={columns}
                    bordered={true}
                    condensed={true}
                    hover={true}
                    tabIndexCell={true}
                    striped={true}
                    search={true}
                    expanded={true}
                    expandable={true}
                    searchable={true}
                    classes="table-dashboard table-sm fs--1 border-bottom border-200 mb-0 table-dashboard-th-nowrap"
                    rowClasses="btn-reveal-trigger border-top border-200"
                    headerClasses="bg-200 text-900 border-y border-200"
                    noDataIndication={() => <div className="text-center">No data found</div>}
                  />
                </div>
              </Fragment>
            )}
              </Col>
            </Row>
          </TabPanel>
        </Tabs>
      </CardBody>
    </>
  );
};

export default SubscriptionLists;
